// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/support/v1/responses.proto (package gportal.api.support.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Ticket } from "./ticket_pb.js";
import { SupportCategory } from "./support_infos_pb.js";
import { SupportAddonPaymentOperationStatus, SupportAddonPrices } from "./support_addons_pb.js";

/**
 * @generated from message gportal.api.support.v1.CreateTicketResponse
 */
export class CreateTicketResponse extends Message<CreateTicketResponse> {
  /**
   * @generated from field: gportal.api.support.v1.Ticket ticket = 1;
   */
  ticket?: Ticket;

  constructor(data?: PartialMessage<CreateTicketResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CreateTicketResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket", kind: "message", T: Ticket },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTicketResponse {
    return new CreateTicketResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTicketResponse {
    return new CreateTicketResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTicketResponse {
    return new CreateTicketResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTicketResponse | PlainMessage<CreateTicketResponse> | undefined, b: CreateTicketResponse | PlainMessage<CreateTicketResponse> | undefined): boolean {
    return proto3.util.equals(CreateTicketResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.GetTicketsResponse
 */
export class GetTicketsResponse extends Message<GetTicketsResponse> {
  /**
   * @generated from field: repeated gportal.api.support.v1.Ticket tickets = 1;
   */
  tickets: Ticket[] = [];

  constructor(data?: PartialMessage<GetTicketsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.GetTicketsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: Ticket, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTicketsResponse {
    return new GetTicketsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTicketsResponse {
    return new GetTicketsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTicketsResponse {
    return new GetTicketsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTicketsResponse | PlainMessage<GetTicketsResponse> | undefined, b: GetTicketsResponse | PlainMessage<GetTicketsResponse> | undefined): boolean {
    return proto3.util.equals(GetTicketsResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.ListSupportInfosResponse
 */
export class ListSupportInfosResponse extends Message<ListSupportInfosResponse> {
  /**
   * The list of available support categories
   *
   * @generated from field: repeated gportal.api.support.v1.SupportCategory categories = 1;
   */
  categories: SupportCategory[] = [];

  /**
   * @generated from field: repeated gportal.api.support.v1.SupportAddonPrices addons = 2;
   */
  addons: SupportAddonPrices[] = [];

  /**
   * Returns true if the user has a payment method on file
   *
   * @generated from field: bool has_payment_method = 3;
   */
  hasPaymentMethod = false;

  /**
   * @generated from field: optional string payment_method_management_url = 4;
   */
  paymentMethodManagementUrl?: string;

  constructor(data?: PartialMessage<ListSupportInfosResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.ListSupportInfosResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "categories", kind: "message", T: SupportCategory, repeated: true },
    { no: 2, name: "addons", kind: "message", T: SupportAddonPrices, repeated: true },
    { no: 3, name: "has_payment_method", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "payment_method_management_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSupportInfosResponse {
    return new ListSupportInfosResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSupportInfosResponse {
    return new ListSupportInfosResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSupportInfosResponse {
    return new ListSupportInfosResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSupportInfosResponse | PlainMessage<ListSupportInfosResponse> | undefined, b: ListSupportInfosResponse | PlainMessage<ListSupportInfosResponse> | undefined): boolean {
    return proto3.util.equals(ListSupportInfosResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.GetTicketResponse
 */
export class GetTicketResponse extends Message<GetTicketResponse> {
  /**
   * @generated from field: gportal.api.support.v1.Ticket ticket = 1;
   */
  ticket?: Ticket;

  constructor(data?: PartialMessage<GetTicketResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.GetTicketResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket", kind: "message", T: Ticket },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTicketResponse {
    return new GetTicketResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTicketResponse {
    return new GetTicketResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTicketResponse {
    return new GetTicketResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTicketResponse | PlainMessage<GetTicketResponse> | undefined, b: GetTicketResponse | PlainMessage<GetTicketResponse> | undefined): boolean {
    return proto3.util.equals(GetTicketResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.CreateSupportMessageResponse
 */
export class CreateSupportMessageResponse extends Message<CreateSupportMessageResponse> {
  /**
   * @generated from field: gportal.api.support.v1.Ticket ticket = 1;
   */
  ticket?: Ticket;

  constructor(data?: PartialMessage<CreateSupportMessageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CreateSupportMessageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket", kind: "message", T: Ticket },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSupportMessageResponse {
    return new CreateSupportMessageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSupportMessageResponse {
    return new CreateSupportMessageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSupportMessageResponse {
    return new CreateSupportMessageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSupportMessageResponse | PlainMessage<CreateSupportMessageResponse> | undefined, b: CreateSupportMessageResponse | PlainMessage<CreateSupportMessageResponse> | undefined): boolean {
    return proto3.util.equals(CreateSupportMessageResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.RateSupportMessageResponse
 */
export class RateSupportMessageResponse extends Message<RateSupportMessageResponse> {
  /**
   * @generated from field: gportal.api.support.v1.RateSupportMessageResponse.RateStatus status = 1;
   */
  status = RateSupportMessageResponse_RateStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<RateSupportMessageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.RateSupportMessageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(RateSupportMessageResponse_RateStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RateSupportMessageResponse {
    return new RateSupportMessageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RateSupportMessageResponse {
    return new RateSupportMessageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RateSupportMessageResponse {
    return new RateSupportMessageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RateSupportMessageResponse | PlainMessage<RateSupportMessageResponse> | undefined, b: RateSupportMessageResponse | PlainMessage<RateSupportMessageResponse> | undefined): boolean {
    return proto3.util.equals(RateSupportMessageResponse, a, b);
  }
}

/**
 * @generated from enum gportal.api.support.v1.RateSupportMessageResponse.RateStatus
 */
export enum RateSupportMessageResponse_RateStatus {
  /**
   * @generated from enum value: RATE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RATE_STATUS_FAILED = 1;
   */
  FAILED = 1,

  /**
   * @generated from enum value: RATE_STATUS_SUCCESSFUL = 2;
   */
  SUCCESSFUL = 2,

  /**
   * @generated from enum value: RATE_STATUS_ALREADY_RATED = 3;
   */
  ALREADY_RATED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(RateSupportMessageResponse_RateStatus)
proto3.util.setEnumType(RateSupportMessageResponse_RateStatus, "gportal.api.support.v1.RateSupportMessageResponse.RateStatus", [
  { no: 0, name: "RATE_STATUS_UNSPECIFIED" },
  { no: 1, name: "RATE_STATUS_FAILED" },
  { no: 2, name: "RATE_STATUS_SUCCESSFUL" },
  { no: 3, name: "RATE_STATUS_ALREADY_RATED" },
]);

/**
 * @generated from message gportal.api.support.v1.CloseTicketResponse
 */
export class CloseTicketResponse extends Message<CloseTicketResponse> {
  /**
   * @generated from field: gportal.api.support.v1.Ticket ticket = 1;
   */
  ticket?: Ticket;

  constructor(data?: PartialMessage<CloseTicketResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CloseTicketResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket", kind: "message", T: Ticket },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloseTicketResponse {
    return new CloseTicketResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloseTicketResponse {
    return new CloseTicketResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloseTicketResponse {
    return new CloseTicketResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CloseTicketResponse | PlainMessage<CloseTicketResponse> | undefined, b: CloseTicketResponse | PlainMessage<CloseTicketResponse> | undefined): boolean {
    return proto3.util.equals(CloseTicketResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.ChargeAddonTicketResponse
 */
export class ChargeAddonTicketResponse extends Message<ChargeAddonTicketResponse> {
  /**
   * @generated from field: gportal.api.support.v1.SupportAddonPaymentOperationStatus status = 1;
   */
  status = SupportAddonPaymentOperationStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<ChargeAddonTicketResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.ChargeAddonTicketResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SupportAddonPaymentOperationStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChargeAddonTicketResponse {
    return new ChargeAddonTicketResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChargeAddonTicketResponse {
    return new ChargeAddonTicketResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChargeAddonTicketResponse {
    return new ChargeAddonTicketResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChargeAddonTicketResponse | PlainMessage<ChargeAddonTicketResponse> | undefined, b: ChargeAddonTicketResponse | PlainMessage<ChargeAddonTicketResponse> | undefined): boolean {
    return proto3.util.equals(ChargeAddonTicketResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.GetFinTokenResponse
 */
export class GetFinTokenResponse extends Message<GetFinTokenResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<GetFinTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.GetFinTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFinTokenResponse {
    return new GetFinTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFinTokenResponse {
    return new GetFinTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFinTokenResponse {
    return new GetFinTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFinTokenResponse | PlainMessage<GetFinTokenResponse> | undefined, b: GetFinTokenResponse | PlainMessage<GetFinTokenResponse> | undefined): boolean {
    return proto3.util.equals(GetFinTokenResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.CancelAddonPaymentResponse
 */
export class CancelAddonPaymentResponse extends Message<CancelAddonPaymentResponse> {
  /**
   * @generated from field: gportal.api.support.v1.SupportAddonPaymentOperationStatus status = 1;
   */
  status = SupportAddonPaymentOperationStatus.UNSPECIFIED;

  /**
   * @generated from field: gportal.api.support.v1.Ticket ticket = 2;
   */
  ticket?: Ticket;

  /**
   * @generated from field: optional string voided_transaction_id = 3;
   */
  voidedTransactionId?: string;

  constructor(data?: PartialMessage<CancelAddonPaymentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CancelAddonPaymentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SupportAddonPaymentOperationStatus) },
    { no: 2, name: "ticket", kind: "message", T: Ticket },
    { no: 3, name: "voided_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelAddonPaymentResponse {
    return new CancelAddonPaymentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelAddonPaymentResponse {
    return new CancelAddonPaymentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelAddonPaymentResponse {
    return new CancelAddonPaymentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelAddonPaymentResponse | PlainMessage<CancelAddonPaymentResponse> | undefined, b: CancelAddonPaymentResponse | PlainMessage<CancelAddonPaymentResponse> | undefined): boolean {
    return proto3.util.equals(CancelAddonPaymentResponse, a, b);
  }
}

